import { getAuth } from '@firebase/auth';
import { Button } from '@mui/material';
import { sendEmailVerification } from 'firebase/auth';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';
import { handleError } from '../../../common/firebase/auth-error.service';
import { severity } from '../../../common/models/severity.enum';
import { isProdOrDevEnv } from '../../../environment.enum';
import { ServiceManager } from '../../../services/service-manager';
import styles from './NotVerified.module.css';

const NotVerified = ({ user, setUser, noreplyEmailAddress }) => {

    const navigate = useNavigate();
    const firstRenderRef = useRef(true);

    const refresh = () => {
        const refreshToken = async () => {
            const auth = getAuth();
            if (auth.currentUser) {
                auth.currentUser.getIdToken(true);
                const token = await auth.currentUser.getIdTokenResult(true);
                setUser({ ...user, token });

                if (token.claims.email_verified) {
                    navigate('/auth/new-user');
                }
            }
        }
        refreshToken();
    }

    useEffect(() => {
        if (!isProdOrDevEnv() && firstRenderRef.current) {
            firstRenderRef.current = false;
            return;
        }
        refresh();
    }, [])

    const send = () => {
        const auth = getAuth();
        sendEmailVerification(auth.currentUser).then(() => {
            ServiceManager.snackbarService.openSnackbar(`Uw verificatie e-mail is verstuurd naar ${auth.currentUser.email}.`, severity.success);
        }).catch(error => {
            handleError(error);
        })
    }

    return (
        <div className={styles.NotVerified} data-testid="NotVerified">
            <>
                <p>
                    Uw e-mailadres is nog niet geverifieerd. U moet op de link klikken die we vanuit <b>{noreplyEmailAddress}</b> naar uw inbox hebben verstuurd. Als u binnen een paar minuten de e-mail niet heeft ontvangen controleer dan uw spambox of probeer het nog een keer via onderstaande knop:
                </p>
                <Button color="primary" variant="contained" onClick={send}>Opnieuw verzenden</Button>
                <p>
                    Geverifeerd op andere browser?
                </p>
                <Button color="secondary" variant="outlined" onClick={refresh}>Verversen</Button>
            </>
        </div >
    )
};

export default NotVerified;
